import React from 'react'

import HeroImage from '../components/hero/HeroImage'
import Quickfinder from '../components/quickfinder/Quickfinder'

const SectionLeasingOfferQuickfinder = ({
  brand = null,
  model = null,
  quickfinderFilters,
}) => (
  <section data-type-mapping="__ignore__">
    <div className="hero pt-0">
      <HeroImage
        bgColor="bg-deep-black"
        imagePath="/images/home/mood/"
        altText="Handshake im Büro"
      />
      <div className="page-container px-5 flex justify-center items-center h-full">
        <div className="quickfinder">
          <Quickfinder
            headline="Jetzt Leasing Angebote vergleichen"
            backgroundColor="white-lucent"
            borderColor="primary"
            initialQueryParams={{ marke: brand, modell: model }}
            hideLeasingRate
            quickfinderFilters={quickfinderFilters}
          />
        </div>
      </div>
    </div>
  </section>
);

export default SectionLeasingOfferQuickfinder;
